// Visuell rendering av TwoColumnsBlock. När renderat inuti canvas-context
// (designläget) får varje kolumn en egen BlockList med drop-zoner och
// nestade BlockContainers — användaren kan klicka i kolumnen, dra in nya
// komponenter och flytta inom kolumnen. Utan context fall-back till passiv
// rendering (preview-pane använder denna).

import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BlockList } from '../blockList';
import { useBlockCanvas } from '../canvasContext';
import { TwoColumnsBlock } from '../types';
import { BlockView } from './index';

type Props = { block: TwoColumnsBlock };

export const TwoColumnsBlockView = ({ block }: Props) => {
  const { t } = useTranslation('groupMessage');
  const ctx = useBlockCanvas();

  if (!ctx) {
    return (
      <Box sx={{ p: '12px 30px' }}>
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            {block.left.map((inner) => (
              <BlockView key={inner.id} block={inner} />
            ))}
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            {block.right.map((inner) => (
              <BlockView key={inner.id} block={inner} />
            ))}
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ p: '12px 30px' }}>
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <BlockList
            blocks={block.left}
            targetFactory={(index) => ({ kind: 'column', parentId: block.id, column: 'left', index })}
            emptyHint={t('builder.canvas.leftColumn')}
          />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <BlockList
            blocks={block.right}
            targetFactory={(index) => ({ kind: 'column', parentId: block.id, column: 'right', index })}
            emptyHint={t('builder.canvas.rightColumn')}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default TwoColumnsBlockView;
